import { BASE_URL_APP } from '@/shared/functions/Functions';
import Link from 'next/link';
import Image from 'next/image';

export default function HeaderPublic() {
  return (
    <header className='d-block'>
      <div className='row w-100 m-0'>
        <div className='col-5 d-flex align-items-center'>
          <Link href={BASE_URL_APP}>
            <Image
              alt='Influence vision logo'
              src='/images/influence-vision-logo.svg'
              height={60}
              width={150}
            />
          </Link>
        </div>
        <div className='col-7 d-flex align-items-center justify-content-end ml-auto'>
          <Link href={BASE_URL_APP}>
            <button className='btn btn-outline-primary'>Sign in</button>
          </Link>
        </div>
      </div>
    </header>
  );
}
